export default __webpack_public_path__ + "static/media/SWT1180.34I-32337_-25819_0.1abacc64.jpg";